









import { PropType, defineComponent } from '@vue/composition-api';
import { Message, RecommendCorpus } from '../../dataType';
import Card from './Card.vue';

export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<RecommendCorpus>>,
      required: true
    }
  }
});
